import { keyBy, startCase } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import {
  getMenusForRevenueCenter,
  getMenusStatus,
} from 'store/RevenueCenters/selector'
import { ReactComponent as IconEmptyImage } from 'assets/icons/IconEmptyImage.svg'
import { createRevenueCenterImageUrl } from 'utils/revenueCenters/links.js'
import { getPickupForConcessions } from 'utils/revenueCenters/getPickupForConcessions'

const RevenueCenterItem = ({ name, id, uuid }) => {
  const history = useHistory()

  const menus = useSelector((state) =>
    getMenusForRevenueCenter(state, id)
  )

  const status = useSelector((state) => getMenusStatus(state, uuid))

  const statusByType = keyBy(status, 'type')

  const onClickItem = () => {
    history.push({ state: { revenueCenterUuid: uuid } })
  }

  return (
    <div className="item">
      <div className="row" onClick={onClickItem} role="button">
        <div className="item-info-wrapper -bold -name-wrapper">
          {name}
        </div>
        <div className="item-info-wrapper -image-wrapper">
          <object
            data={createRevenueCenterImageUrl(uuid)}
            type="image/webp"
            className="item__image -empty-image"
          >
            <IconEmptyImage />
          </object>
        </div>
        <div className="item-info-wrapper -menus-status-wrapper">
          <div className="menu-statuses">
            {menus.map(({ uuid, serviceType, displayName }) => (
              <div className="item-type" key={uuid}>
                <span
                  className={`item-type__dot  -${
                    statusByType[
                      getPickupForConcessions(
                        serviceType
                      ).toUpperCase()
                    ]?.availability ?? 'on'
                  }`}
                ></span>
                <p>
                  <span className="item-type--bold">
                    {startCase(getPickupForConcessions(serviceType))}
                  </span>
                  :
                  <span className="menu-item-container">
                    <span className="menu-item">{displayName}</span>
                  </span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RevenueCenterItem
